import { configureStore } from '@reduxjs/toolkit';
import ewayBillCompareReducer from './ewayBillCompareSlice';

const ewayBillCompareStore = configureStore({
  reducer: {
    ewayBillCompare: ewayBillCompareReducer,
  },
});

export default ewayBillCompareStore;
